import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';

export default (...input: Parameters<typeof classnames>) => twMerge(classnames(...input));
